import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { connect } from "react-redux";

import "./RecoverCard.component.scss";
import RecoverForm from "./RecoverForm/RecoverForm.component";
import { ActionCreator } from "../../../../../actions/actions";
import { AuthActionCreators } from "../../../actions/actionCreators";
import {SubmitButtonStrings} from "../UtilFormInputs/SubmitButton/SubmitButton.strings";
import {authStoreSelectors} from "../../../store/store";

export const availablePages = ["Recover", "AfterRecover"];

export interface RecoverCardProps {
    recover: ActionCreator;
    onChangePage: any;
    redirectLogin: boolean;
}

export interface RecoverCardState {
    currentPage: string;
}

class RecoverCard extends Component<RecoverCardProps, RecoverCardState> {

    constructor(_props) {
        super(_props);
        this.state = {
            currentPage: availablePages[0]
        };
    }

    componentDidUpdate() {
        if (this.props.redirectLogin && this.state.currentPage === "Recover") {
            this.setState({
                currentPage: availablePages[1]
            });
        }
    }

    render() {
        return (
            <div id="RecoverCard">
                {this.state.currentPage === "Recover" ?
                    <div>
                        <div className="title-1">Reset Password</div>
                        <div className="title-2">Please enter your email to reset your old password</div>

                        <RecoverForm
                        onSubmit={this.props.recover}
                        onChangePage={this.props.onChangePage}
                        />
                    </div>
                    :
                    <div>
                        <div className="title-1">Reset Password</div>
                        <div className="title-3">
                            Your password has been reset successfully! <br />
                            Please, go to your email, we have sent a code to your email.
                        </div>

                        <button
                            type="button"
                            className="red-btn"
                            onClick={() => this.props.onChangePage(0)}
                        >
                            {SubmitButtonStrings.LOGIN}
                        </button>
                    </div>
                }

            </div>
        );
    }
}

const mapStateToProps = state => ({
    redirectLogin: authStoreSelectors.redirectLogin(state)
});

const mapDispatchToProps = {
    recover: AuthActionCreators.recover
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecoverCard);
